<template>
  <div>
    <a-table
      size="middle"
      :columns="columns"
      :data-source="items"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    >
      <div slot="status" slot-scope="status, record">
        <div v-if="['part_checkresourced', 'all_checkresourced'].includes(record.status_slug)">
          <a @click="showCheckResourceRecordModal(record.id)">{{ status }}</a>
        </div>
        <div v-else>
          {{ status }}
        </div>
      </div>

      <div slot="item_no" slot-scope="item_no, record">
        <div v-if="isShowMenu('agent_pre_order_items/show')">
          <a @click="showInfoModal(record.id)">{{ item_no }}</a>
        </div>
        <div v-else>
          {{ item_no }}
        </div>
      </div>
    </a-table>

    <!-- 详情模态框 -->
    <show-agent-pre-order-item
      v-if="isShowInfoModal"
      :visible.sync="isShowInfoModal"
      :id="showingId"
      @showModal="showOperateModal"
    />

    <!-- 核库模态框 -->
    <check-store-agent-pre-order-item
      v-if="isShowCheckStoreModal"
      :visible.sync="isShowCheckStoreModal"
      :id="showingId"
      @completed="fetchData"
    />

    <!-- 核资模态框 -->
    <check-resource-cards-to-top-agent
      v-if="isShowCheckResourceModal"
      :visible.sync="isShowCheckResourceModal"
      :id="showingId"
      @completed="fetchData"
    />

    <!-- 取消模态框 -->
    <cancel-agent-pre-order-item
      v-if="isShowCancelModal"
      :visible.sync="isShowCancelModal"
      :id="showingId"
      @completed="fetchData"
    />

    <!-- 采购完成模态框 -->
    <finished-agent-pre-order-item
      v-if="isShowFinishedModal"
      :visible.sync="isShowFinishedModal"
      :id="showingId"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { formatCurrency } from '@/utils/filter'

export default {
  name: 'AgentPreOrderItemsList',
  components: {
    ShowAgentPreOrderItem: () => import('@/views/agent_pre_order_items/show/index'),
    CheckStoreAgentPreOrderItem: () => import('@/views/agent_pre_order_items/CheckStore'),
    CheckResourceCardsToTopAgent: () => import('@/views/agent_pre_order_items/CheckResource'),
    CancelAgentPreOrderItem: () => import('@/views/agent_pre_order_items/Cancel'),
    FinishedAgentPreOrderItem: () => import('@/views/agent_pre_order_items/Finished')
  },
  props: {
    items: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      required: true,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      isShowInfoModal: false,
      isShowCheckStoreModal: false,
      isShowCheckResourceModal: false,
      isShowCancelModal: false,
      isShowFinishedModal: false,
      showingId: 0
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '项目状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          fixed: 'left'
        },
        {
          title: '项目编号',
          dataIndex: 'item_no',
          scopedSlots: { customRender: 'item_no' },
          fixed: 'left'
        },
        {
          title: '产品类型',
          dataIndex: 'product_type',
          fixed: 'left'
        },
        {
          title: '产品名称',
          dataIndex: 'product_name',
          ellipsis: true
        },
        {
          title: '运营商种类',
          dataIndex: 'carrier_type'
        },
        {
          title: '用户业务模式',
          dataIndex: 'user_business_type'
        },
        {
          title: '产品周期',
          dataIndex: 'service_cycle'
        },
        {
          title: '产品容量',
          dataIndex: 'package_capacity'
        },
        {
          title: '卡品',
          dataIndex: 'card_type'
        },
        {
          title: '周期数',
          dataIndex: 'service_period'
        },
        {
          title: '采购数量',
          dataIndex: 'product_count'
        },
        {
          title: '产品价格(元)',
          dataIndex: 'distributor_price',
          customRender: formatCurrency
        },
        {
          title: '卡板价格',
          dataIndex: 'card_type_price'
        },
        {
          title: '产品费用(元)',
          dataIndex: 'product_fee',
          customRender: formatCurrency
        },
        {
          title: '卡板费用(元)',
          dataIndex: 'card_fee',
          customRender: formatCurrency
        },
        {
          title: '小计(元)',
          dataIndex: 'total_fee',
          customRender: formatCurrency
        },
        {
          title: '产品备注',
          dataIndex: 'remark',
          width: 150,
          ellipsis: true
        }
      ]
    }
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    showInfoModal(recordId) {
      this.showingId = recordId
      this.isShowInfoModal = true
    },

    showCheckResourceRecordModal(recordId) {
      this.showingId = recordId
      this.isShowCheckResourceRecordsModal = true
    },

    showOperateModal(type) {
      if (type === 'check_store') {
        this.isShowCheckStoreModal = true
      } else if (type === 'check_resource') {
        this.isShowCheckResourceModal = true
      } else if (type === 'cancel') {
        this.isShowCancelModal = true
      } else if (type === 'pending_purchase') {
        this.isShowFinishedModal = true
      }
    },

    fetchData() {
      this.$emit('completed')
    }
  }
}
</script>

<style scoped>

</style>
